module.exports = __webpack_public_path__ + "static/03-2de562d7348afbf5da8ae35534a02911.png";